import {
  ColorsError900,
  ColorsNeutral200,
  ColorsNeutral500,
  ColorsPrimary500,
  ColorsPrimary900,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const rowWrapper = css({
  '&.MuiStack-root': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 38,
  },
});

const hiddenRow = css({
  '&.MuiStack-root': {
    display: 'none',
  },
});

const rowTitle = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral500,
  },
});

const rowValue = css({
  '&.MuiTypography-root': {
    color: ColorsPrimary900,
  },
});

const deleteAction = css({
  '.MuiSvgIcon-root': {
    color: ColorsError900,
  },
  '.MuiListItemText-root': {
    color: ColorsError900,
  },
});

const cardHeader = css({
  '&.MuiCardHeader-root': {
    borderBottom: `1px solid ${ColorsNeutral200}`,
  },
});

const switchWrapper = css({
  '& .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)': {
    '& .MuiSwitch-thumb': {
      backgroundColor: ColorsPrimary500,
    },
    '& +.MuiSwitch-track': {
      backgroundColor: `${ColorsPrimary500} !important`,
    },
  },
});
const switchLabel = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral500,
  },
});

const InfoCardStyles = {
  rowWrapper,
  rowTitle,
  rowValue,
  deleteAction,
  switchWrapper,
  switchLabel,
  cardHeader,
  hiddenRow,
};

export default InfoCardStyles;
